import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProfitCalculator from "@/components/ProfitCalculator";
import Payouts from "@/components/Payouts";
import CTABanner from "@/components/CTABanner";
import { PageBreadcrumb, RelatedLinks } from "@/components/SEOBlocks";

const CALC_RELATED = [
  { to: "/challenges",      label: "Browse Challenges", tagline: "Instant, 1-Step & 2-Step" },
  { to: "/general-rules",   label: "Trading Rules",     tagline: "Drawdown & targets" },
  { to: "/payout-protector",label: "Payout Protector",  tagline: "Insure your first payout" },
  { to: "/faq",             label: "FAQ",               tagline: "60+ answered questions" },
];

export default function CalculatorFullPage() {
  return (
    <div data-testid="page-calculator-full" className="relative overflow-x-hidden">
      <Navbar />
      <main className="pt-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 mt-6 mb-6">
          <PageBreadcrumb items={[{ label: "Calculator" }]} />
          <div className="pill-mono inline-flex mb-4">Profit Calculator</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight mb-3">
            Project your <span className="text-gradient-brand font-semibold">monthly payout</span>
          </h1>
          <p className="text-[color:var(--text-2)] text-sm lg:text-base font-light max-w-2xl">
            Pick an account size, a target monthly return, and we'll show your net payout after OFunded's gain share. Defaults assume the 90% Gold tier.
          </p>
        </div>
        <ProfitCalculator />
        <Payouts />

        <RelatedLinks items={CALC_RELATED} />
      </main>
      <CTABanner />
      <Footer />
    </div>
  );
}
